// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.5
//   protoc               v4.23.4
// source: consumer/consumer.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "consumer";

export interface Consumer {
  id: string;
  peerId: string;
  producerPeerId: string;
  spatialLayer?: number | undefined;
  temporalLayer?: number | undefined;
}

function createBaseConsumer(): Consumer {
  return { id: "", peerId: "", producerPeerId: "", spatialLayer: undefined, temporalLayer: undefined };
}

export const Consumer: MessageFns<Consumer> = {
  encode(message: Consumer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.peerId !== "") {
      writer.uint32(18).string(message.peerId);
    }
    if (message.producerPeerId !== "") {
      writer.uint32(26).string(message.producerPeerId);
    }
    if (message.spatialLayer !== undefined) {
      writer.uint32(32).uint32(message.spatialLayer);
    }
    if (message.temporalLayer !== undefined) {
      writer.uint32(40).uint32(message.temporalLayer);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Consumer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConsumer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.peerId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.producerPeerId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.spatialLayer = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.temporalLayer = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Consumer {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      peerId: isSet(object.peerId) ? globalThis.String(object.peerId) : "",
      producerPeerId: isSet(object.producerPeerId) ? globalThis.String(object.producerPeerId) : "",
      spatialLayer: isSet(object.spatialLayer) ? globalThis.Number(object.spatialLayer) : undefined,
      temporalLayer: isSet(object.temporalLayer) ? globalThis.Number(object.temporalLayer) : undefined,
    };
  },

  toJSON(message: Consumer): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.peerId !== "") {
      obj.peerId = message.peerId;
    }
    if (message.producerPeerId !== "") {
      obj.producerPeerId = message.producerPeerId;
    }
    if (message.spatialLayer !== undefined) {
      obj.spatialLayer = Math.round(message.spatialLayer);
    }
    if (message.temporalLayer !== undefined) {
      obj.temporalLayer = Math.round(message.temporalLayer);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Consumer>, I>>(base?: I): Consumer {
    return Consumer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Consumer>, I>>(object: I): Consumer {
    const message = createBaseConsumer();
    message.id = object.id ?? "";
    message.peerId = object.peerId ?? "";
    message.producerPeerId = object.producerPeerId ?? "";
    message.spatialLayer = object.spatialLayer ?? undefined;
    message.temporalLayer = object.temporalLayer ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
